/**
 * Utility for managing code editor theme preferences
 */

const EDITOR_THEME_KEY = 'code_editor_theme_preference';

/**
 * Get saved editor theme preference
 * @returns {string} - Theme name (default: 'vs-dark')
 */
export const getEditorThemePreference = () => {
  try {
    const saved = localStorage.getItem(EDITOR_THEME_KEY);
    // Migrate old 'light' value to 'vs'
    if (saved === 'light') {
      localStorage.setItem(EDITOR_THEME_KEY, 'vs');
      return 'vs';
    }
    return saved || 'vs-dark';
  } catch (error) {
    console.error('Error loading editor theme preference:', error);
    return 'vs-dark';
  }
};

/**
 * Save editor theme preference
 * @param {string} theme - Theme name to save
 */
export const saveEditorThemePreference = (theme) => {
  try {
    localStorage.setItem(EDITOR_THEME_KEY, theme);
  } catch (error) {
    console.error('Error saving editor theme preference:', error);
  }
};

/**
 * Get theme based on app theme or saved preference
 * @param {string} appTheme - Current app theme ('dark' or 'light')
 * @param {boolean} useSavedPreference - Whether to use saved preference
 * @returns {string} - Monaco editor theme name
 */
export const getMonacoTheme = (appTheme, useSavedPreference = true) => {
  if (useSavedPreference) {
    return getEditorThemePreference();
  }
  return appTheme === 'dark' ? 'vs-dark' : 'vs';
};

/**
 * Available Monaco editor themes
 */
export const MONACO_THEMES = [
  { value: 'vs', label: '☀️ Light' },
  { value: 'vs-dark', label: '🌙 Dark' },
  { value: 'hc-black', label: '⚫ High Contrast Black' },
  { value: 'hc-light', label: '⚪ High Contrast Light' }
];
